import React, { FC, useMemo } from "react";
import { Button, Table, Upload, Tooltip, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { IMaterialDetailModel, useSaleOrderDetailModel } from "./saleOrderDetailModel";
import { RouterParamType } from "@/model/navModel";
import { importPropsConfig } from "@/utils/importFile";
import { DetailType, ISalesTypeEnum, IPriceTypeEnum } from "@/types/ScmEnums";
import { IDetailList } from "../../saleOrderTypes";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { formatNum, formatIntPoint, formatIntPoint1 } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import useGlobalModel from "@/model/globalModel";
import { YhBut } from "@/components/YhButton";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { shopAndOrg: { shopId } } = useGlobalModel()

    const {
        setAddModalVisible,
        detailAddForm,
        detailEditForm,
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        addSaleType,
        setDetaiAddDataRow,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataSource,
        detailDetailList,
        downloadTpl,
        transformsToPoDetailList,
        setHistoryVisible,
        setHistoryRow,
        setTopButsControl
    } = useSaleOrderDetailModel();
    let { priceTypeCode, salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const importCallback = async (list: IMaterialDetailModel[]) => {
        if (!list) return;
        let newImportList = await Promise.all(list?.map(async (item) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, retailPrice, num, ...params } = item as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = latestPurPrice ?? purchasePrice;
            if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = lateSalePrice ?? retailPrice;
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = retailPrice;
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = latestPurPrice ?? purchasePrice;
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = purchasePrice ?? latestPurPrice;
                        break;
                }
            }
            return {
                ...item,
                id: stockId,
                num,
                price: newPrice,
            }
        }))
        transformsToPoDetailList(mode, newImportList)
    }
    const addModal = () => {
        if (!salesTypeCode) {
            message.warning("请选择销售类型");
            return;
        }
        if (!customerCode) {
            message.warning("请选择客户");
            return;
        }
        setAddModalVisible(true)
    }
    const action = <>
        {mode !== "look" && <>
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => addModal()}
                >新增配件</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { detailDetailList(mode) }}
                >批量删除</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_IM}>
                <Upload
                    beforeUpload={(file, fileList) => {
                        if (!salesTypeCode) {
                            message.warning("请选择销售类型");
                            return false;
                        }
                        if (!customerCode) {
                            message.warning("请选择客户");
                            return false;
                        }
                        return true
                    }}
                    showUploadList={false}
                    className="mr-10 ml-10"
                    {...importPropsConfig(`/zzw-vrm/sale/order/details/import/${shopId}`, importCallback)}>
                    <Button
                        disabled={!(salesTypeCode && customerCode)}
                        className="mr-5"
                        type="primary"
                        shape="round">导入</Button>
                </Upload>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_DLOAD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={downloadTpl}
                >下载模板</Button>
            </YhAuth>
        </>
        }
    </>

    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
        }, {
            title: '订单数量',
            width: 100,
            dataIndex: 'num',
            editable: mode != "look" ? true : false,
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: mode != "look" ? true : false,
        }, {
            title: '金额',
            width: 100,
            dataIndex: 'notAmount',
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            editable: mode != "look" ? true : false,
            suffix: "%",
            render: (text: string) => text + '%'
        }, {
            title: '零件金额',
            width: 100,
            dataIndex: 'amount',

        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '库存数量',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: mode != "look" ? true : false,
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => {
                mode != "look" && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
            }
        }
    ];

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }

    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "saleOrder", "roleCodes": roles };
        return getRoleColumns("saleOrder", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleSave = (row: IDetailList) => {
        let { num, price, discountRate, purchasePrice, inventoryNum, latestPurPrice, termNum } = row
        let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : purchasePrice
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        num = +formatIntPoint(num)
        // num =mode==="add"? +formatIntPoint(num, inventoryNum, "选择数量>=可用库存数量"):+formatIntPoint(num, termNum?termNum:inventoryNum, "选择数量>=可用库存数量");  //数量

        price = +formatIntPoint1(price, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);  //价格
        price = +formatNum(price);
        discountRate = +formatNum(discountRate);
        let newRow = {
            ...row,
            price,
            discountRate,
            num,
            notAmount: +formatNum(num * price),
            amount: +formatNum((num * price * discountRate) / 100),
        }

        let newData = mode === "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];

        // //判断仓库变化时，  重置货位
        // if (newRow.warehouseCode !== newData[index].warehouseCode) {
        //     newRow.shelfCode = undefined
        // }
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                // rowClassName='editable-row yh-edit-table-tr'
                rowClassName={(record) => {
                    if (+Number(record.num) > +(record.inventoryNum ?? 0)) return "editable-row yh-edit-table-tr background-FFB4B4";
                    return "editable-row yh-edit-table-tr"
                }}
                rowKey={record => record.detailsId as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}